import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  linkActiveClass:'active',
  // mode: 'history',
  routes: [
    {
      path: '/index',
      component: () => import('@/views/index')
    },
    {
      path: '/currency',//贷币
      component: () => import('@/views/currency')
    },
    {
      path: '/repayment',//还款详情
      component: () => import('@/views/repayment')
    },
    {
      path: '/repayment2',//还款详情
      component: () => import('@/views/repayment2')
    },
    {
      path: '/currencyRecord',
      component: () => import('@/views/currencyRecord')
    },
    {
      path: '/subscription',//新币申购
      component: () => import('@/views/subscription')
    },
    {
      path: '/subscribe',//新币申购
      component: () => import('@/views/subscribe')
    },
    {
      path: '/login',
      component: () => import('@/views/login')
    },
    {
      path: '/register',
      component: () => import('@/views/register')
    },
    {
      path: '/text',
      component: () => import('@/views/text')
    },
    {
      path: '/bannerDetail',
      component: () => import('@/views/bannerDetail')
    },
    {
      path: '/agrt',
      component: () => import('@/views/agrt')
    },
    {
      path: '/agreement',
      component: () => import('@/views/agreement')
    },
    {
      path: '/about',
      component: () => import('@/views/about')
    },
    {
      path: '/help',
      title: '帮助中心列表',
      component: () => import('@/views/help')
    },
    {
      path: '/helpDetail',
      title: 'helpDetail',
      component: () => import('@/views/helpDetail')
    },
    {
      path: '/forgetpwd',
      title: '忘记密码',
      component: () => import('@/views/forgetpwd')
    },
    {
      path: '/bindmpwd',
      title: '设置交易密码',
      component: () => import('@/views/bindmpwd')
    },
    {
      path: '/bindphone',
      title: '绑定手机号码',
      component: () => import('@/views/bindphone')
    },
    {
      path: '/deal',
      title: '币币交易',
      component: () => import('@/views/deal/index')
    },
    {
      path: '/market',
      title: '行情',
      component: () => import('@/views/market')
    },
    {
      path: '/deal_c',
      title: '合约交易',
      component: () => import('@/views/deal/deal_c')
    },
    {
      path: '/deal_jg',
      title: '交割合约',
      component: () => import('@/views/deal/deal_jg')
    },
    {
      path: '/lt',
      title: '合约持仓',
      component: () => import('@/views/deal/leverTransactions')
    },
    {
      path: '/jgcc',
      title: '交割持仓',
      component: () => import('@/views/deal/jgcc')
    },
    {
      path: '/all',
      title: '全部',
      component: () => import('@/views/deal/allDeal')
    },
    {
      path: '/dealList',
      title: '交易记录',
      component: () => import('@/views/deal/leverList')
    },
    {
      path: '/notice',
      title: '公告中心',
      component: () => import('@/views/notice')
    },
    {
      path: '/profit_index',
      title: '搬砖获利',
      component: () => import('@/views/profit/profit_index')
    },
    {
      path: '/profit_wdtg',
      title: '我的托管',
      component: () => import('@/views/profit/profit_wdtg')
    },
    {
      path: '/profit_buy',
      title: '购买',
      name: 'profit_buy',
      component: () => import('@/views/profit/profit_buy')
    },
    {
      path: '/downLoad',
      title: '下载',
      component: () => import('@/views/downLoad')
    },
    {
      path: '/recharge',
      title: '充币',
      component: () => import('@/views/recharge')
    },
    {
      path: '/money',
      title: '提币',
      component: () => import('@/views/money')
    },
    // {
    //   path: '/view',
    //   title: 'view',
    //   component: () => import('@/views/deal/view')
    // },
    {
      path: '/asset',
      redirect: '/table1',
      component: () => import('@/views/asset/index'),
      children: [
        {
          path: '/table1',
          component: () => import('@/views/asset/asset-table1')
        },
        {
          path: '/table2',
          component: () => import('@/views/asset/asset-table2')
        },
        {
          path: '/record',
          title: '记录',
          component: () => import('@/views/asset/asset-record')
        },
        {
          path: '/transfer',
          title: '划转',
          component: () => import('@/views/asset/asset-transfer')
        },
        // {
        //   path: '/recharge',
        //   title: '充币',
        //   component: () => import('@/views/asset/asset-recharge')
        // },
        // {
        //   path: '/money',
        //   title: '提币',
        //   component: () => import('@/views/asset/asset-money')
        // },
        {
          path: '/address',
          title: '提币地址管理',
          component: () => import('@/views/asset/asset-address')
        }
      ]
    },
    {
      path: '/person',
      component: () => import('@/views/person/index'),
      redirect: '/setting',
      children: [
        {
          path: '/setting',
          title: '账户设置',
          component: () => import('@/views/person/person-zhsz')
        },
        {
          path: '/deallog',
          title: '交易日志',
          component: () => import('@/views/person/person-jyrz')
        },
        {
          path: '/tbjl',
          title: '提币记录',
          component: () => import('@/views/person/person-tbjl')
        },
        {
          path: '/subscriptionList',
          title: '申购记录',
          component: () => import('@/views/person/person-subscriptionList')
        },
        {
          path: '/cbjl',
          title: '充币记录',
          component: () => import('@/views/person/person-cbjl')
        },
        {
          path: '/kjmbSelect',
          title: '快捷买币列表',
          component: () => import('@/views/person/person-kjmbSelect')
        },
        {
          path: '/kjmb',
          title: 'kjmb',
          component: () => import('@/views/person/person-kjmb')
        },
        {
          path: '/credit',//信用分
          title: 'credit',
          component: () => import('@/views/person/person-credit')
        },
        {
          path: '/receive',
          title: '收款设置',
          component: () => import('@/views/person/person-sksz')
        },
        {
          path: '/sfyz',
          title: '身份验证',
          component: () => import('@/views/person/person-sfyz')
        },
        {
          path: '/smauth',
          title: '实名认证',
          component: () => import('@/views/person/person-smrz')
        },
        {
          path: '/seniorauth',
          title: '高级认证',
          component: () => import('@/views/person/person-gjrz')
        },
        {
          path: '/dzrz',
          title: '地址认证',
          component: () => import('@/views/person/person-dzrz')
        },
        {
          path: '/mypromotion',
          title: '我的推广',
          component: () => import('@/views/person/person-wdtg')
        },
        {
          path: '/authentication',
          title: '身份认证',
          component: () => import('@/views/person/person-sfrz')
        },
        {
          path: '/service',
          title: '在线客服',
          component: () => import('@/views/person/service')
        },
        {
          path: '/news',
          title: '消息列表',
          component: () => import('@/views/person/news')
        },
        {
          path: '/newsDetail',
          title: 'newsDetail',
          component: () => import('@/views/person/newsDetail')
        },
      ]
    },
    {
      path: '/security',
      component: () => import('@/views/security')
    },
    {
      path: '/preciousMetal',
      title: 'preciousMetal',
      component: () => import('@/views/preciousMetal/contractTransaction')
    },
    {
      path: '/contractTransaction',
      title: 'contractTransaction',
      component: () => import('@/views/preciousMetal/contractTransaction')
    },
    {
      path: '/positionList',//贵金属交割持仓
      title: '交割持仓',
      component: () => import('@/views/preciousMetal/positionList')
    },
    {
      path: '/leverTransactions',//贵金属永续持仓
      title: '永续合约',
      component: () => import('@/views/preciousMetal/leverTransactions')
    },
    {
      path: '*',
      component: () => import('@/views/404')
    },
    {
      path: '/',
      component: () => import('@/views/index')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js